import React from 'react';
import { useToggle } from 'react-use';
import { Common } from '@thecvlb/design-system/lib/src';

import FAQ from 'modals/FAQ';

import { getItems } from '../GreatChoice/greatChoice.settings';
import NextStepCard from '../GreatChoice/NextStepCard';

import { QualifiedTypes } from './qualified.types';

const Qualified: React.FC<QualifiedTypes> = ({ onContinue, userCurrentPPType }) => {
  const [isFAQOpen, toggleIsFAQOpen] = useToggle(false);
  const isCareOnlyPPType = userCurrentPPType === 'care-only';

  const items = getItems(isCareOnlyPPType, 'Wegovy', true);

  return (
    <>
      <FAQ
        isOpen={isFAQOpen}
        type="eligible"
        onClose={toggleIsFAQOpen}
        medication="semaglutide"
        screen="qualified-for-sema-plus"
        planType={userCurrentPPType}
      />
      <div className="flex h-full grow flex-col">
        <div className="flex flex-col gap-4 py-6">
          <div className="flex flex-col items-center gap-2 text-center">
            <p className="font-bold text-primary-700">Great news!</p>
            <h2 className="text-m2xl font-bold text-primary-700 md:text-2xl">
              You’re prequalified for a custom compound!
            </h2>
            <p>
              Just a heads-up: Your renewal process will be a bit different, and we’ll need to
              update your plan.
            </p>
            <p className="font-bold text-primary">
              {isCareOnlyPPType ? 'Next steps:' : 'First, we’ll need to change your plan:'}
            </p>
          </div>
          <div className="flex flex-col">
            {items.map((item, index) => (
              <NextStepCard {...item} key={index} showSeparator={index !== items.length - 1} />
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center gap-3 max-md:mt-auto md:mx-auto">
          <Common.Button color="blue" fullWidthOnMobile onClick={onContinue}>
            Continue
          </Common.Button>
          <Common.Button color="white-alt" fullWidthOnMobile onClick={toggleIsFAQOpen}>
            FAQs
          </Common.Button>
        </div>
      </div>
    </>
  );
};

export default Qualified;
